<template>
  <section id="testimonialVideos" class="mt-5">
    <div class="box--wrapper">
      <div class="container">
        <div v-for="section in filteredSections" :key="section.type" class="slideWrapper">
          <testimonial-videos-slider :entries="section.entries" :section="section" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { computed } from 'vue';
const sections = require('../videosTestimonials.json');

export default {
  props: {
    filterType: {
      type: String,
      default: 'all' // Mögliche Werte: 'female', 'male', 'all'
    }
  },
  setup(props) {
    const filteredSections = computed(() => {
      if (props.filterType === 'all') {
        return sections;
      } else {
        return sections.map(section => ({
          ...section,
          entries: section.entries.filter(entry => entry.id.includes(props.filterType))
        }));
      }
    });

    return {
      filteredSections
    };
  },
}
</script>